module.exports = __webpack_public_path__ + "static/media/Spotify-Video-Podcasts.692a2ac3.jpg";